import React from "react";
import ReactDOM from "react-dom";
import "./assets/scss/style.scss";
import "./assets/scss/reset.scss";
import 'react-alice-carousel/lib/alice-carousel.css';
import App from "./App";

const inch = Math.sqrt(window.screen.availHeight**2 + window.screen.availWidth**2) / 96
console.log(inch);

if(inch > 25){
    document.body.style["zoom"]= "80%";
}
else if(inch > 20){
    document.body.style["zoom"]= "60%";
}
else if(inch > 10){
    document.body.style["zoom"]= "50%";
}
else if(inch > 5){
    document.body.style["zoom"]= "10%";
}

ReactDOM.render(<App />, document.getElementById("root"));
